<mat-chip-list>
  <mat-chip *ngFor="let chip of chips" [color]="chip.color || 'default'" selected class="mini-chip" [disabled]="chip.isDisabled">
    {{chip.text}}
  </mat-chip>
</mat-chip-list>
